module.exports = __webpack_public_path__ + "static/media/amazon.b6dc087f.png";